<template>
  <div class="agreen flex_between">
    <div class="agreenL">
      <h3 class="title">牛盾用户协议</h3>
      <p class="item"><a ><i class="icon icon_document"></i>隐私协议</a></p>
      <p class="item"><a href="#document2"><i class="icon icon_document"></i>服务协议</a></p>
      <p class="item"><a href="#document3"><i class="icon icon_document"></i>法律声明</a></p>
    </div>
    <div class="agreenR">
      <div id="">
        <h3 class="doc_title"><i class="icon_sanjiao el-icon-caret-right"></i>隐私协议</h3>
        <div class="section">
          <h4 class="p_title">一、隐私权保护</h4>
          <div class="wrap">
            <p>(1) 一旦您同意本协议或使用本服务,您即同意本公司按照以下条款来使用和披露您的个人信息。</p>
            <p>
              在您注册为Newdun.com™用户时,我们会要求您设置用户名和密码来识别您的身份,请正确填写您的相关信息,以便在您丢失密码时用以确认您的身份。您仅可通过您设置的密码来使用该账户,如果您泄漏了密码,您可能会丢失您的个人识别信息,并可能导致对您不利的法律后果。该账户和密码因任何原因受到潜在或现实危险时,您应该立即和本公司取得联系,在本公司采取行动前,本公司对此不负任何责任。</p>
          </div>
          <div class="wrap">
            <p>(2) 注册信息</p>
            <p>您注册该账户时应向本公司提供您的真实姓名、电话号码和电子邮件地址。为有针对性地向您提供新的服务和机会,您了解并同意本公司将通过您的电子邮件地址或手机号码通知您这些信息。</p>
          </div>
          <div class="wrap">
            <p>(3) 广告</p>
            <p>本公司会对Newdun.com™用户的身份数据进行综合统计,并出于销售和奖励的需要使用或披露。</p>
          </div>
          <div class="wrap">
            <p>(4) Cookie的使用</p>
            <p>您了解并同意,本公司使用cookie来使本网站对用户更友好,它可以帮您省去为使用我们的服务而重复输入注册信息和跟踪您的浏览器的状态。</p>
          </div>
          <div class="wrap">
            <p>(5)为更为有效的向您提供服务,您同意,本公司有权将您注册及使用本服务过程中所提供、形成的信息提供给本公司关联公司。除本协议另有规定外,本公司不对外公开或向 第三方提供您的信息，但以下情况除外：</p>
            <p>A、事先获得您的明确授权；</p>
            <p>B、只有披露您的个人资料,才能提供您需要的产品和（或）服务；</p>
            <p>C、按照本协议的要求进行的披露；</p>
            <p>D、根据法律法规的规定；</p>
            <p>E、按照政府主管部门的要求；</p>
            <p>F、为维护本公司及其关联公司的合法权益；</p>
            <p>G、您使用Newdun.com™账户成功登录过的其他网站；</p>
          </div>
          <div class="wrap">
            <p>(6)我们尊重他人的知识产权,如果您发现存在通过使用Newdun.com™服务,侵犯您的著作权、商标或者其他财产时,您可发送通知给到本公司,为保证有效,通知必须包括：</p>
            <p>A、尽可能详尽的指出遭到侵犯或其他信息足以指定遭侵权的作品信息;</p>
            <p>B、确定您声称侵犯了上述第一条所列的受版权保护的作品的材料;</p>
            <p>C、提供您有效联系方式;</p>
            <p>D、提供足够的信息,如有可能的话,能够让我们联系到涉嫌侵权网页或其他信息的所有者或管理员;</p>
            <p>E、在提供的侵权通知中声明:“我宣誓,根据伪证处罚,该通知中的信息准确无误,并且我是版权所有者或我有权代表涉嫌被侵权的专有权利的所有者。”;</p>
            <p>F、文件底部,签署有效名称以及公章;</p>
            <p>G、将信函书面发送到一下地址：;</p>
            <p>联系方式： 杭州牛盾网络技术有限公司</p>
            <p>地址： 浙江省杭州市余杭区仓前街道文一西路1001号衢时代A座2层杭州牛盾网络</p>
            <p>电话： 0571-8861-6565</p>
          </div>
          <div class="wrap">
            <h4 class="p_title">二、 信息的存储和交换</h4>
            <p>您的信息和资料存储在位于中国的服务器上,为了备份的需要,本公司可能将您的信息和资料传送到所属本公司位于别国的服务器上,并承诺用户信息不会出售行为。</p>
          </div>
          <div id="document2" class="wrap">
            <h4 class="p_title">三、 免责声明</h4>
            <p>本网站含有到其他网站的链接,但本公司对其他网站的隐私保护措施不负任何责任。本公司可能在任何需要的时候增加商业伙伴或共用品牌的网站。</p>
          </div>
          <div class="wrap">
            <h4 class="p_title">四、 安全</h4>
            <p>本公司仅按现有技术提供相应的安全措施来使本公司掌握的信息不丢失,不被滥用和变造。这些安全措施包括向其它服务器备份数据和对用户密码加密。尽管有这些安全措施,但本公司不保证这些信息的绝对安全。</p>
          </div>
        </div>
      </div>
      <div  >
        <h3 class="doc_title"><i class="icon_sanjiao el-icon-caret-right"></i>服务协议</h3>
        <h4 class="p_title">一、 声明与承诺</h4>
        <div class="wrap">
          <p>
            1.您在使用Newdun.com™服务之前,请务必充分阅读本条款并同意本声明。您一旦使用Newdun.com™提供的服务或通过其他方式使用Newdun.com™的服务,即表示您对本协议声明的内容无异议,并遵守本协议所有约定。</p>
        </div>
        <div class="wrap">
          <p>2.本公司有权对本协议内容进行单方面变更,并在本网站以公告形式公布,无需另行通知；若您继续使用本公司提供的服务,即表示您对变更后的内容已确认,无异议；若有异议,请立即跟本公司协商或停止使用本服务。</p>
        </div>
        <div class="wrap">
          <h4 class="p_title">二、安全和密码</h4>
          <p>
            您对您账号密码的安全性全权负责。您必须妥善保管好您的账户密码,因您自身引起的账号密码泄露所造成的损失,由您自行承担。您保证不向其他人泄露您的账号密码,不得与其他人共享您的账号。如果您转让或者共享您的账户,本公司有权立刻终止您的账户。本公司人员不会以任何理由索取您的密码。</p>
        </div>
        <div class="wrap">
          <h4 class="p_title">三、Newdun.com™用户责任和义务</h4>
          <p>1.
            您在使用本服务时应遵守中华人民共和国相关法律法规、您所在国家或地区之法令及所有适用的法律和法规,不将本服务用于任何非法目的,也不以任何非法方式使用本服务,并且您对您通过使用Newdun.com™服务所造成的不良影响承担全部责任。</p>
        </div>
        <div class="wrap">
          <p>2. 您不得利用本服务从事侵害他人合法权益之行为,否则本公司有权拒绝提供本服务,且您应承担所有相关法律责任,因此导致本公司或本公司用户受损的，您应承担赔偿责任。上述行为包括但不限于：</p>
          <p>(1) 侵害他人名誉权、隐私权、商业秘密、商标权、著作权、专利权或任何一方的其他专有合法权益。</p>
          <p>(2) 违反依法定或约定之保密义务。</p>
          <p>(3) 冒用他人名义使用本服务。</p>
          <p>(4) 从事不法行为,如制作色情、赌博、病毒、挂马、反动、外挂、私服、以及为私服提供任何服务(比如支付、SEO)的类似网站。</p>
          <p>(5) 提供赌博资讯或以任何方式引诱他人参与赌博。</p>
          <p>(6) 从事任何可能含有电脑病毒或是可能侵害本服务系统、资料之行为。</p>
          <p>(7) 其他本公司有正当理由认为不适当之行为。</p>
        </div>
        <div class="wrap">
          <h4 class="p_title">四、终止条款</h4>
          <p>1. 您理解并同意，本公司不对因下述任一情况导致的任何损害赔偿承担责任,包括但不限于流量、访问、数据等方面的损失或其他无形损失的损害赔偿 (无论本公司是否已被告知该等损害赔偿的可能性)：</p>
        </div>
        <div class="wrap">
          <p>(1) 本公司有权基于单方判断,包含但不限于本公司认为您已经违反本协议的明文规定及精神,暂停、中断或终止向您提供本服务或其任何部分,并移除您的资料。</p>
          <p>(2) 本公司在发现非法网站或有疑义或有违反法律规定或本协议约定之虞时,有权不经通知先行暂停或终止该域名的服务,并拒绝您使用本服务之部分或全部功能。</p>
          <p>(3) 您同意,在必要时本公司无需事先通知即可终止提供本服务,并暂停、关闭或删除该账户及您账号中所有相关资料及档案,并将您滞留在该账户的全部合法资金退回到您的银行账户。</p>
          <p>(4) 您同意,本公司配合公司当地执法部分调查取证违反法律法规或影响网络安全等行为。</p>
          <p>(5) 您同意,本公司不负责因您或第三方任何原因终止或暂停,或由我们因以上条款采取终止或暂停措施而造成的损害或索赔。</p>
        </div>
        <div class="wrap">
          <p>2.
            如您需要注销您的Newdun.com™账户,应先经本公司审核同意。本公司注销该账户,即表明本公司与您之间的协议已解除,但您仍应对您使用本服务期间的行为承担可能的违约或损害赔偿责任,同时本公司仍可保有您的相关信息。</p>
        </div>
      </div>
      <div id="document3">
        <h3 class="doc_title"><i class="icon_sanjiao el-icon-caret-right"></i>法律声明</h3>
        <div class="wrap">
          <h4 class="p_title">一、 系统中断或故障</h4>
          <p>系统因下列状况无法正常运作,使您无法使用各项服务时,本公司不承担损害赔偿责任,该状况包括但不限于：</p>
        </div>
        <div class="wrap">
          <p>(1) 本公司在本网站公告之系统停机维护期间。</p>
          <p>(2) 电信设备出现故障不能进行数据传输的。</p>
          <p>(3) 因台风、地震、海啸、洪水、停电、战争、恐怖袭击等不可抗力之因素,造成本公司系统障碍不能执行业务的。</p>
          <p>(4) 由于黑客攻击、电信部门技术调整或故障、网站升级、银行方面的问题等原因而造成的服务中断或者延迟。</p>
        </div>
        <div class="wrap">
          <h4 class="p_title">二、 责任范围及责任限制</h4>
          <p>(1) 本公司仅对本协议中列明的责任承担范围负责。</p>
          <p>(2) 由于服务的DNS服务器故障给您造成大范围域名无法解析超过48小时的，除收费用户外您无权要求本公司给予经济赔偿。</p>
        </div>
        <div class="wrap">
          <h4 class="p_title">三、 商标、知识产权的保护</h4>
          <p>(1) 本网站上所有内容,包括但不限于著作、图片、档案、资讯、资料、网站架构、网站画面的安排、网页设计,均由本公司或本公司关联企业依法拥有其知识产权，包括但不限于商标权、专利权、著作权、商业秘密等。</p>
          <p>(2) 非经本公司或本公司关联企业书面同意,任何人不得擅自使用、修改、复制、公开传播、改变、散布、发行或公开发表本网站程序或内容。</p>
          <p>(3) 尊重知识产权是您应尽的义务,如有违反,您应承担损害赔偿责任。</p>
        </div>
        <div class="wrap">
          <h4 class="p_title">四、 法律适用与管辖</h4>
          <p>
            本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律,没有相关法律规定的,参照通用国际商业惯例和（或）行业惯例。因本协议产生之争议,均应依照中华人民共和国法律予以处理,并以杭州市余杭区人民法院为第一审管辖法院。</p>
        </div>


      </div>
    </div>

    <!--返回顶部-->
    <returnTop></returnTop>
  </div>
</template>

<script>
  import footBar from '../components/footerbar'
  import returnTop from '../components/returnTop'
  import Case from '../components/case'

  export default {
    name: "product2",
    data() {
      return {}
    },
    components: {
      footBar, Case,returnTop
    },
    /* mounted() {

     },
     methods: {

     },*/

  }
</script>

<style scoped lang="scss">
  .agreen {
    width: 1200px;
    margin: 80px auto 0;
    min-height: 200px;
    padding: 30px 0;
    .agreenL {
      width: 180px;
      text-align: left;
      .title {
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        color: #000000;

      }
      .item {
        height: 40px;
        line-height: 40px;
        border-top: 1px solid #EEEEEE;
        .icon_document {
          display: inline-block;
          width: 24px;
          height: 22px;
          background: url("../assets/product.svg") -2432px -228px;
          position: relative;
          top: 6px;
        }
        > a {
          text-decoration: none;
          font-size: 14px;
          color: #4A4A4A;
        }
        > a:hover, > a:active {
          cursor: pointer;
          color: #0D72FD;
          .icon_document {
            background: url("../assets/product.svg") -2432px -188px;
          }
        }
      }
      .item:nth-child(4){
        border-bottom:1px solid #eee;
      }
    }
    .agreenR {
      text-align: left;
      width: 980px;
      .doc_title {
        .icon_sanjiao {
          width: 16px;
          color: #2F87Ff;
          margin-bottom: 30px;
          position: relative;
          left: -6px;
        }
      }
      .wrap {
        margin-bottom: 20px;
        font-size: 14px;
        color: #2B2B2B;
        letter-spacing: 0;
        line-height: 20px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/agreeMent.vue